var map = {
	"./lunr.da": 86,
	"./lunr.da.js": 86,
	"./lunr.de": 87,
	"./lunr.de.js": 87,
	"./lunr.du": 88,
	"./lunr.du.js": 88,
	"./lunr.es": 89,
	"./lunr.es.js": 89,
	"./lunr.fi": 90,
	"./lunr.fi.js": 90,
	"./lunr.fr": 91,
	"./lunr.fr.js": 91,
	"./lunr.hu": 92,
	"./lunr.hu.js": 92,
	"./lunr.it": 93,
	"./lunr.it.js": 93,
	"./lunr.jp": 94,
	"./lunr.jp.js": 94,
	"./lunr.multi": 95,
	"./lunr.multi.js": 95,
	"./lunr.no": 96,
	"./lunr.no.js": 96,
	"./lunr.pt": 97,
	"./lunr.pt.js": 97,
	"./lunr.ro": 98,
	"./lunr.ro.js": 98,
	"./lunr.ru": 99,
	"./lunr.ru.js": 99,
	"./lunr.stemmer.support": 53,
	"./lunr.stemmer.support.js": 53,
	"./lunr.sv": 100,
	"./lunr.sv.js": 100,
	"./lunr.tr": 101,
	"./lunr.tr.js": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;